import * as React from 'react'

import { type Colors, NumberBadge, Text } from '@factorialco/deprecated-design-system'

interface Props {
  rating?: number | null
  showEmpty?: boolean
}

export const ScoreRating = ({ rating, showEmpty = true }: Props) => {
  if (!rating) {
    if (!showEmpty) return null

    return <Text.Normal>-</Text.Normal>
  }

  const color = colorForRating(rating)

  return <NumberBadge label={rating} textColor="grey000White" color={color} />
}

export const colorForRating = (rating: number): Colors => {
  if (rating < 3) {
    return 'radicalRed1000'
  }

  if (rating < 4) {
    return 'champagne1000'
  }

  return 'lime1000'
}
